import React, { Fragment, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ComposedChart, Line, Area, Label, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Scatter, ResponsiveContainer, LineChart } from 'recharts';
import Title from './Title';
import { formatSalaryChartData } from '../utils/formatData';
import data from '../data/enrollment_split.json';

{/* <LineChart>
     <XAxis dataKey="date" xAxisId={"benchmark"} interval={datesInterval} />
     <XAxis hide={true} dataKey="date" xAxisId={"value"} interval={datesInterval} />                              
      <YAxis />                            
       <Line xAxisId={"value"}  data={assets.complexAssetChartData} type="monotone" dataKey="value" stroke="#8884d8" dot={null} activeDot={{ r: 8 }} />
       <Line xAxisId={"benchmark"} data={assets.benchmarkChartData} type="monotone" dataKey="benchmark" stroke="#82ca9d" dot={null} activeDot={{ r: 8 }} />
 </LineChart> */}

export default function EnrollLineChart({ chartTitle, chartData }) {
  const theme = useTheme();

  console.log('enroll', data);

  const displayData = data.data;
  return (
    <Fragment>
      <Title>{chartTitle}</Title>
      <ResponsiveContainer width='100%' height='100%'>
        <LineChart width={730} height={250} data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey="year" xAxisId={"250906"} scale='band' />
          <XAxis hide={true} dataKey="year" xAxisId={"234903"} scale='band' /> 
          <XAxis hide={true} dataKey="year" xAxisId={"234909"} scale='band' />      
          <XAxis hide={true} dataKey="year" xAxisId={"234904"} scale='band' />      
          <XAxis hide={true} dataKey="year" xAxisId={"116906"} scale='band' />      
          <XAxis hide={true} dataKey="year" xAxisId={"250903"} scale='band' />      
          <XAxis hide={true} dataKey="year" xAxisId={"250904"} scale='band' />           
          <YAxis />
          <Tooltip />
          <Legend />
          <Line xAxisId={"250906"} name='ALBA-GOLDEN ISD' data={displayData.data_250906} type='monotone' dataKey='fall_survey_enrollment' stroke='blue' />
          <Line xAxisId={"234903"} name='EDGEWOOD ISD' data={displayData.data_234903} type='monotone' dataKey='fall_survey_enrollment' stroke='purple' />
          <Line xAxisId={"234909"} name='FRUITVALE ISD' data={displayData.data_234909} type='monotone' dataKey='fall_survey_enrollment' stroke='green' />
          <Line xAxisId={"234904"} name='GRAND SALINE ISD' data={displayData.data_234904} type='monotone' dataKey='fall_survey_enrollment' stroke='orange' />
          <Line xAxisId={"116906"} name='LONE OAK ISD' data={displayData.data_116906} type='monotone' dataKey='fall_survey_enrollment' stroke='#8884d8' />
          <Line xAxisId={"250903"} name='MINEOLA ISD' data={displayData.data_250903} type='monotone' dataKey='fall_survey_enrollment' stroke='green' />
          <Line xAxisId={"250904"} name='QUITMAN ISD' data={displayData.data_250904} type='monotone' dataKey='fall_survey_enrollment' stroke='#8884d8' />
        </LineChart>
      </ResponsiveContainer>
    </Fragment>
  );
}
